import { render, staticRenderFns } from "./dowload.vue?vue&type=template&id=bb4f38d8&"
import script from "./dowload.vue?vue&type=script&lang=js&"
export * from "./dowload.vue?vue&type=script&lang=js&"
import style0 from "./dowload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports